import React, { useEffect} from "react";
import gsap from 'gsap';

//Imagen de ISO
import vasoIso from '../assets/inicio/banner/vasopowerpuffgirl/banner04_iso01.webp';

//Imagen de Vaso
import vasoTop from '../assets/inicio/banner/vasopowerpuffgirl/vaso-top.png';
import girlHuge from '../assets/inicio/banner/vasopowerpuffgirl/the_power_puff_girls-huge.png';

const AnimacionVasoLogo = () => {
   useEffect(() => {
    const vasoMovePower = document.getElementById("vaso-move-powerpuffgirl");
    const isoMove = document.getElementById("isomove");
    if (!vasoMovePower) return;
    if (!isoMove) return;

    const maskImgPower = vasoMovePower.querySelector(".powerpuffgirl img");

    if (maskImgPower) {
      const tlImgPower = gsap.timeline({ repeat: -1, yoyo: false });
      tlImgPower
        // Establecer posición inicial
        .set(maskImgPower, {
          x: 0,
          y: 15,
          scale: 1,
          rotate: 0,
        })
        // Delay inicial
        .to(maskImgPower, { duration: 1 })
        // Vaso gira a la derecha (simula rotación)
        .to(maskImgPower, {
          x: 80,
          y: 15,
          scale: 1,
          rotate: -5,
          duration: 2,
          ease: "power2.inOut",
        })
        // Continúa girando más a la derecha
        .to(maskImgPower, {
          x: 120,
          y: 15,
          scale: 1,
          rotate: -8,
          duration: 2,
          ease: "power2.inOut",
        })
        // Regresa al centro (gira de vuelta)
        .to(maskImgPower, {
          x: 80,
          y: 15,
          scale: 1,
          rotate: -5,
          duration: 2,
          ease: "power2.inOut",
        })
        // Vuelve a posición inicial
        .to(maskImgPower, {
          x: 0,
          y: 15,
          scale: 1,
          rotate: 0,
          duration: 2,
          ease: "power2.inOut",
        })
        ;
    }

   const timeVaso = gsap.timeline({ repeat: -1, yoyo: false });
    timeVaso
      // Establecer posición inicial: primer plano al frente
      .set(vasoMovePower, {
        x: 0,
        rotate: -16,
        scale: 1.4,
        filter: 'blur(0px)',
        zIndex: 15,
      })
      // Delay inicial
      .to(vasoMovePower, { duration: 1 })
      // Vaso empieza a moverse a la izquierda y se va al fondo
      .to(vasoMovePower, {
        x: -80,
        rotate: -12,
        scale: 1.0,
        filter: 'blur(0.5px)',
        zIndex: 5,
        duration: 2,
        ease: "power2.inOut",
      })
      // Vaso se va completamente al fondo (derecha)
      .to(vasoMovePower, {
        x: 100,
        rotate: 10,
        scale: 0.85,
        filter: 'blur(1.5px)',
        zIndex: 4,
        duration: 2,
        ease: "power2.inOut",
      })
      // Vaso regresa del fondo hacia el centro
      .to(vasoMovePower, {
        x: -40,
        rotate: -14,
        scale: 1.2,
        filter: 'blur(0px)',
        zIndex: 15,
        duration: 2,
        ease: "power2.inOut",
      })
      // Vaso regresa a posición inicial (primer plano)
      .to(vasoMovePower, {
        x: 0,
        rotate: -16,
        scale: 1.4,
        filter: 'blur(0px)',
        zIndex: 15,
        duration: 2,
        ease: "power2.inOut",
      })
      ;

    const timeIso = gsap.timeline({repeat: -1, yoyo:false});
      timeIso
        // Establecer posición inicial: atrás (borroso, pequeño)
        .set(isoMove, {
          x: 100,
          y: -20,
          scale: 0.8,
          filter: 'blur(2px)',
          zIndex: 3,
        })
        // Delay inicial
        .to(isoMove, { duration: 1 })
        // ISO empieza a venir al frente desde la derecha
        .to(isoMove,{
          x: 50,
          y: -10,
          scale: 1.0,
          filter: 'blur(1px)',
          zIndex: 10,
          duration: 2,
          ease: "power2.inOut",
        })
        // ISO llega completamente al frente (izquierda)
        .to(isoMove,{
          x: -120,
          y: 0,
          scale: 1.4,
          filter: 'blur(0px)',
          zIndex: 16,
          duration: 2,
          ease: "power2.inOut",
        })
        // ISO empieza a regresar al fondo
        .to(isoMove,{
          x: 30,
          y: -15,
          scale: 1.0,
          filter: 'blur(1.5px)',
          zIndex: 5,
          duration: 2,
          ease: "power2.inOut",
        })
        // ISO regresa a posición inicial (atrás)
        .to(isoMove,{
          x: 100,
          y: -20,
          scale: 0.8,
          filter: 'blur(2px)',
          zIndex: 3,
          duration: 2,
          ease: "power2.inOut",
        })
        ;


  }, []);


  return (
    <>
    <div id="vaso" className="wrap vasopower" style={{ marginTop:'48px'}}>
      <div id="vaso-move-powerpuffgirl">
        <div className="mask1 powerpuffgirl">
          <img src={girlHuge} alt="Power Puff Girl" style={{width:'auto', height:'70%'}}/>
        </div>
        <img src={vasoTop} id='top'  alt="Vaso top" 
          style={{
            width:'360px', 
            height:'445px', 
            position:'absolute', 
            top:'0', 
            left:'0', 
            zIndex:'3', 
            pointerEvents:'none'
          }} />
      </div>
      <div id="isomove" className="contIso" style={{ position: 'absolute' }}>
        <img
            src={vasoIso}
            id="iso"
            className="iconIso"
            alt="Logo Iso"
          />
      </div>
      </div>
    </>
  );
};

export default AnimacionVasoLogo;
